import {createSvgIcon} from '../create-svg-icon';

export const LastPageIcon = createSvgIcon(
  <path d="M5.59 7.41 10.18 12l-4.59 4.59L7 18l6-6-6-6-1.41 1.41zM16 6h2v12h-2V6z" />
, 'LastPageOutlined');
